import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { StyledTable } from '@lp/lp-ui';
import { BulkRowFailureModel } from '../../typings';

interface BulkFailuresDialogProps {
    open: boolean;
    label: string;
    failures: BulkRowFailureModel[];
    onClose: () => void;
}

const BulkFailuresDialog: React.FC<BulkFailuresDialogProps> = ({ open, label, failures, onClose }) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>{label} — rows not processed</DialogTitle>
        <DialogContent>
            <Typography variant="body2" color="text.secondary" mb={2}>
                Row numbers count the addresses that were submitted, header row excluded.
            </Typography>
            <StyledTable size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '10%' }}>Row</TableCell>
                        <TableCell sx={{ width: '35%' }}>Email</TableCell>
                        <TableCell>Reason</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {failures.map(f => (
                        <TableRow key={`${f.rowNumber}-${f.email}`}>
                            <TableCell>{f.rowNumber}</TableCell>
                            <TableCell>{f.email}</TableCell>
                            <TableCell>{f.reason}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </StyledTable>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Close</Button>
        </DialogActions>
    </Dialog>
);

export default BulkFailuresDialog;
